import { useState } from "react";
import { Link } from "react-router-dom";
import { api, errMsg } from "../lib/api";
import { HardHat } from "lucide-react";
import { btnPrimary, inputCls, Field } from "../components/Modal";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setDone(data);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="w-full max-w-sm space-y-5" data-testid="forgot-page">
        <div className="flex items-center gap-3">
          <div className="h-11 w-11 rounded-xl bg-accent flex items-center justify-center"><HardHat className="h-6 w-6 text-accent-foreground" /></div>
          <div className="font-heading font-extrabold text-xl">QuincailleriePro</div>
        </div>
        <h1 className="font-heading text-2xl font-bold">Mot de passe oublié</h1>
        {done ? (
          <div className="space-y-4" data-testid="forgot-success">
            <div className="p-3 rounded-lg bg-emerald-50 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300 text-sm font-medium">{done.message}</div>
            {done.dev_reset_link && (
              <div className="p-3 rounded-lg bg-blue-50 dark:bg-blue-950 text-sm space-y-2">
                <p className="text-blue-700 dark:text-blue-400 text-xs">Mode démo (aucun serveur email configuré) — utilisez ce lien :</p>
                <a data-testid="dev-reset-link" href={done.dev_reset_link} className="text-primary font-semibold hover:underline break-all text-xs">{done.dev_reset_link}</a>
              </div>
            )}
            <Link to="/login" className="text-primary text-sm font-semibold hover:underline">← Retour à la connexion</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            {error && <div data-testid="forgot-error" className="p-3 rounded-lg bg-rose-50 text-rose-700 dark:bg-rose-950 dark:text-rose-300 text-sm font-medium">{error}</div>}
            <Field label="Votre email">
              <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} />
            </Field>
            <button data-testid="forgot-submit" disabled={loading} className={`${btnPrimary} w-full h-11`}>
              {loading ? "Envoi..." : "Réinitialiser mon mot de passe"}
            </button>
            <Link to="/login" className="block text-center text-primary text-sm font-semibold hover:underline">← Retour à la connexion</Link>
          </form>
        )}
      </div>
    </div>
  );
}
